import { isAndIos } from "@/utils/auth.js"

const webviewBridge = {
  count: 0,
  _setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge)
    } /*else {
      if (this.count > 3) return
      this.count++
      setTimeout(() => {
        this._setupWebViewJavascriptBridge(callback)
      }, 150)
    }*/
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback)
    }
    window.WVJBCallbacks = [callback]
    let WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  }
}

// app返回上一级
export function appFinish() {
  window.location.href = "protocol://action/finish/"
}
// app登出
export function Logout() {
  window.location.href = "protocol://action/logout/"
}
// 绑定
export function bind_ec() {
  window.location.href = "protocol://action/bind_ec"
}
// 通过native 跳第有导航栏的H5页面
export function goUrl(url) {
  if(isAndIos()){
    if(window.bridge){
      window.bridge.loadDomainUrl(url)
    }
  }else{
    window.location.href = url
  }
}

// 设置状态栏
export function setStateBarColor(color = '#ffffff', alpha = 1, textColor = 0) {
  window.location.href = `protocol://action/stateBarColor?color=${color}&alpha=${alpha}&textwhite=${textColor}`
}

// 打开一个新的页面 通过native 跳第3方地址
export function goNewWebview(url, hasTitle = '1', title = '', isReload = '1') {
  if(isAndIos()){
    if(window.bridge){
      window.bridge.toNewWebActivity(url, hasTitle, title, isReload)
    }
  }else{
    webviewBridge._setupWebViewJavascriptBridge((bridge)=>{
      bridge.callHandler('toNewWebActivity',{
        url,
        hasTitle,
        title,
        isReload
      })
    })
  }
}

// 保存图片到相册
export function saveImage(base64Str, url, callback) {
  if (isAndIos()) {
    if (window.bridge) {
      //注册js回调方法
      window.downImgCallJS = callback
      //保存到相册
      window.bridge.downImg(base64Str, url)
    }
  } else {
    //注册js回调方法
    webviewBridge._setupWebViewJavascriptBridge(bridge => {
      bridge.registerHandler('downImgCallJS', callback)
    })
    //保存到相册
    webviewBridge._setupWebViewJavascriptBridge(bridge => {
      bridge.callHandler('downImg', {
        base64Str: base64Str,
        url: url
      })
    })
  }
}
